const init = () => {
    const benefitsListBlock = document.querySelector('.benefits-list-block')
    const bottomWrapper = document.getElementById('benefits-list-block__bottom-wrapper')

    if (!benefitsListBlock)
        return

    setCssClassesForViewPortSize()

    function setCssClassesForViewPortSize() {
        let isDt = benefitsListBlock.clientWidth >= 910
        if (isDt) {
            bottomWrapper.classList.remove('benefits-list-block__bottom-wrapper--mobile')
            bottomWrapper.classList.add('benefits-list-block__bottom-wrapper--desktop')
        } else {
            bottomWrapper.classList.remove('benefits-list-block__bottom-wrapper--desktop')
            bottomWrapper.classList.add('benefits-list-block__bottom-wrapper--mobile')
        }
    }
    window.addEventListener('resize', () => setCssClassesForViewPortSize())
}
document.addEventListener('DOMContentLoaded', init)
